export default function Excel_Data_Bars() {
  return <div>Excel_Data_Bars</div>;
}
